import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import { setGraphBaselineValue, setGraphAnnotationValue } from '../actions/index';
import GraphAnnotation from '../../../containers/graphAnnotation.js';
import GraphPlotline from '../../../containers/graphPlotline.js';
import AnnotationsFactory from 'highcharts/modules/annotations';
import { getAverageLine, getTrendData, getTrendLine } from '../../../../../chartUtils/utlis.js';
AnnotationsFactory(Highcharts);
Exporting(Highcharts);
ExportingData(Highcharts);


function getMaxValue(arr){
    if(arr.length){
        let value  = Math.max(...arr);
        return value;    
    }
}

function twentyPercentOf(value) {
    return (value * 20) / 100;
}



function getMaxValue(arr){
    if(arr.length){
        let value  = Math.max(...arr);
        return value;    
    }
}

function twentyPercentOf(value) {
    return (value * 20) / 100;
}
class SkillAcquisitionGraph extends Component {

    constructor(props) {
        super(props);        
        this.state = {            
            sliderMaxValue: props.yAxisMaxValue ? props.yAxisMaxValue : 100,
            sliderValue: props.yAxisMaxValue ? props.yAxisMaxValue : 100,
            AnnotationLabel : this.props.dataAnnotationLabel || [],
            BaselineLabel : this.props.dataBaselineLabel || [],
            xAxisDateOption: [],
          };
        this.onSliderChange = this.onSliderChange.bind(this);
        this.setAnnotationState = this.setAnnotationState.bind(this);
        this.setBaselineState = this.setBaselineState.bind(this);
      }

    componentDidMount = () => {
        this.highchartsHandler();
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.dataBaselineLabel !== null && nextProps.dataBaselineLabel !== this.props.dataBaselineLabel)
        {
            this.setState({
                BaselineLabel: nextProps.dataBaselineLabel && nextProps.dataBaselineLabel[0] != undefined ? nextProps.dataBaselineLabel : [],
            },()=> this.highchartsHandler());
        }

        if(nextProps.dataAnnotationLabel !== null && nextProps.dataAnnotationLabel !== this.props.dataAnnotationLabel)
        {
            this.setState({
                AnnotationLabel: nextProps.dataAnnotationLabel
            },()=> this.highchartsHandler());
        }
    }


     // This method will be sent to the child component
     setAnnotationState(AnnotationState) {    
        let annotationLabel = this.props.dataAnnotationLabel || [];      
        annotationLabel.push(AnnotationState);       
        this.setState({
            AnnotationLabel: annotationLabel
        },()=>this.highchartsHandler());

        this.props.setGraphAnnotationValue(this.state.AnnotationLabel);
    }

    // This method will be sent to the child component
    setBaselineState(BaselineState) {   
        let BaselineLabel = this.props.dataBaselineLabel || [];      
        let BaselineLabel1 = [];        
        BaselineLabel1.push(BaselineState[BaselineState.length - 1]);         
        BaselineState = [...BaselineLabel, ...BaselineLabel1];            
       // BaselineLabel.concat(BaselineState);        
        this.props.setGraphBaselineValue(BaselineState)        
    }

    highchartsHandler = () => {
        let finalData = [];
        let targetId = [];
        let xAxisDateBeforeSorting = [];
        let xAxisDate = [];
        // let FromDate = moment(this.props.FromDate, 'YYYY-MM-DD');
        // let ToDate = moment(this.props.ToDate, 'YYYY-MM-DD');
        // let diff = ToDate.diff(FromDate, 'days', false);
        // diff = diff + 1;
        let xAxisLabel = this.props.xAxisName === undefined ? 'Data' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? 'Date' : this.props.yAxisName;
        let disableYaxislabel = this.props.disableYaxislabel;
        let disableXaxislabel = this.props.disableXaxislabel;
        let disableLegend = this.props.disableLegend;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
        let displayAverage = this.props.displayAverage;
        let seriesSum = 0, seriesCount = 0, avgPlotLine = {}, baselineFlag = true, masteredlineFlag = true;
        let plotLines = [];
        //let selectedProgram = this.props.selectedProgram;
        let selectedProgram = this.props.graphTitle;        
        if (this.props.dataAnalytics.DCPatientSkillAcqGraphData !== null && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.length > 0) {
            this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.map((obj, index) => {
                let dataObj = {}
                let targetData = [];
                let goaldataForDate = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                for (let i = 0; i < goaldataForDate.length; i++) {
                    if(xAxisDateBeforeSorting.indexOf(moment(goaldataForDate[i].dos).format('MM/DD/YYYY')) === -1)
                    {
                        xAxisDateBeforeSorting.push(moment(goaldataForDate[i].dos).format('MM/DD/YYYY'));
                    }
                }

                if(this.props.displaySavedPhaseChangeLines)
                {
                    let phaseChangeLineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionPhaseChangeLineGraphs;  
                    for (let k = 0; k < phaseChangeLineData.length; k++) {                          
                        let lineIndex = xAxisDateBeforeSorting.indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));                     
                        if(lineIndex === -1)
                        {
                            xAxisDateBeforeSorting.push(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));
                        }
                    }                    
                }

                if(this.props.displayPhaseChangeLineForBaseline)
                {
                    let phaseChangeBaselineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                    for (let k = 0; k < phaseChangeBaselineData.length; k++ ) {      
                        if(phaseChangeBaselineData[k].dateMetBaseline !== '1900-01-01T00:00:00' && k === 0)
                        {                 
                            let lineIndex = xAxisDateBeforeSorting.indexOf(moment(phaseChangeBaselineData[k].lineDate).format('MM/DD/YYYY'));       
                            if(baselineFlag && lineIndex === -1)
                            {
                                xAxisDateBeforeSorting.push(moment(phaseChangeBaselineData[k].dateMetBaseline).format('MM/DD/YYYY'));
                                baselineFlag = false;
                            }
                        }
                    }                    
                }

                if(this.props.displayphaseChangeLineWhenTheGoalWasMastered)
                {
                    let phaseChangeMasteredlineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                    for (let k = 0; k < phaseChangeMasteredlineData.length; k++) {                         
                        if(phaseChangeMasteredlineData[k].dateMastered !== '1900-01-01T00:00:00' && k === 0)
                        {                        
                            let lineIndex =xAxisDateBeforeSorting.indexOf(moment(phaseChangeMasteredlineData[k].dateMastered).format('MM/DD/YYYY'));           
                            if(masteredlineFlag && lineIndex === -1)
                            {
                                xAxisDateBeforeSorting.push(moment(phaseChangeMasteredlineData[k].dateMastered).format('MM/DD/YYYY'));
                                masteredlineFlag = false;
                            }   
                        }
                    }                
                }

                // xAxisDateBeforeSorting.sort((date1, date2) => {
                //     date1 = date1.split('/').reverse().join('');
                //     date2 = date2.split('/').reverse().join('');
                //     return date1.localeCompare(date2);
                // });

                xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));

                for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
                {  
                    xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
                }

                if(targetId.indexOf(obj.targetId) === -1)
                {
                    let goaldata = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.filter((op) => op.targetId === obj.targetId);
                    targetData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].targetName;
                        dataObj['targetId'] = goaldata[i].targetId;
                        targetId.push(goaldata[i].targetId);
                        if(xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            targetData[index] = goaldata[i].targetData;
                            // targetData.push(goaldata[i].targetData);
                            seriesSum += parseFloat(goaldata[i].targetData);
                            seriesCount += 1;
                        }
                    }

                    for(let j = 0; j < xAxisDate.length; j++)
                    {
                        //if(!targetData[j])
                        if(targetData[j] == undefined || targetData[j] < 0)
                        {
                            targetData[j] = null;
                        }
                    }
                    if (displayAverage && seriesCount > 0 && seriesCount > 0) {
                        var seriesAvg = (seriesSum / seriesCount).toFixed(2);
                        avgPlotLine = {
                                                value: seriesAvg,
                                                color: '#000000',
                                                width: 2,
                                                dashStyle: 'shortdash',
                                                id: 'avgPlotLine1',
                                                label: {
                                                    text: seriesAvg
                                                }
                                            }
                      }
                    dataObj['data'] = targetData;
                    finalData.push(dataObj);
                }
            })


            if(this.props.phaseChangeLineDataFlag && this.props.phaseChangeBaselineDataFlag && this.props.phaseChangeMasteredlineDataFlag && !this.props.displaySavedPhaseChangeLines && !this.props.displayPhaseChangeLineForBaseline && !this.props.displayphaseChangeLineWhenTheGoalWasMastered)
            {
                this.setState({ BaselineLabel: [] });
            }
    
            if(this.state.BaselineLabel && (this.state.BaselineLabel[0] === undefined || this.state.BaselineLabel[0] !== 'undefined'))
            {
                this.setState({BaselineLabel : [] });
            }
            if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionPhaseChangeLineGraphs;        
                let BaselineState = this.state.BaselineLabel;  
                for (let k = 0; k < phaseChangeLineData.length; k++) {    
                        let lineIndex = xAxisDate.indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));    
                        var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                            if(data && data.date === phaseChangeLineData[k].lineDate)
                                return true;
                        });
                    
                        if (indexValue !== -1) 
                            this.state.BaselineLabel.splice(indexValue, 1);
    
                        if(indexValue === -1 && Number(lineIndex) >= 0 && phaseChangeLineData[k].lineLabel)
                        {  
                            let label = {
                                            id: 'plotLine_' + Math.random(),
                                            value: Number(lineIndex),
                                            color: '#000000',
                                            width: 2,
                                            date:phaseChangeLineData[k].lineDate,
                                            key: phaseChangeLineData[k].lineLabel,  
                                            dashStyle: phaseChangeLineData[k].lineTypeName,                   
                                            label: {
                                                text: phaseChangeLineData[k].lineLabel
                                            },
                                            events: {
                                                dblclick: function(e) {
                                                    this.axis.removePlotLine(this.id)
                                                }
                                            }
                                        };
                                      
                            BaselineState.push(label);                                    
                        }
                    
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);                  
            }
            else if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && !this.props.displaySavedPhaseChangeLines && this.state.BaselineLabel && this.state.BaselineLabel.length > 0)
            {
                let phaseChangeLineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionPhaseChangeLineGraphs;
                //let BaselineState = this.state.BaselineLabel;  
                
                for (let k = 0; k < phaseChangeLineData.length; k++) {                         
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data && data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    if (indexValue !== -1) 
                        this.state.BaselineLabel.splice(indexValue, 1);            
                }
                this.props.setPhaselineState(false);       
                this.props.setGraphBaselineValue(this.state.BaselineLabel);             
                //this.setBaselineState(BaselineState);  
            }
            
    
            if(this.props.phaseChangeBaselineDataFlag && xAxisDate.length > 0 && this.props.displayPhaseChangeLineForBaseline)
            {
                let phaseChangeBaselineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                let BaselineState = this.state.BaselineLabel;  
                for (let k = 0; k < phaseChangeBaselineData.length; k++ ) {    
                    if(phaseChangeBaselineData[k].dateMetBaseline != '1900-01-01T00:00:00' && k === 0)
                    {                 
                        let lineIndex =xAxisDate.indexOf(moment(phaseChangeBaselineData[k].dateMetBaseline).format('MM/DD/YYYY'));          
                        var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                            
                            if(data && data.key === 'Baseline')
                                return true;
                        });
                        // if (indexValue !== -1) 
                        //     this.state.BaselineLabel.splice(indexValue, 1);    
    
                        if(indexValue === -1 && Number(lineIndex) >= 0)
                        {                        
                            let label = {
                                            id: 'plotLine_' + Math.random(),
                                            value: Number(lineIndex),
                                            color: '#000000',
                                            width: 2,
                                            key: "Baseline",
                                            dashStyle: phaseChangeBaselineData[k].baselineTypeName,                   
                                            label: {
                                                text: "Baseline"
                                            }
                                        };
                            
                            BaselineState.push(label);                                    
                        }
                    }
                }
                this.props.setBaselineState(false);
                this.setBaselineState(BaselineState);                  
            }
            else if(this.props.phaseChangeBaselineDataFlag && xAxisDate.length > 0 && !this.props.displayPhaseChangeLineForBaseline && this.state.BaselineLabel && this.state.BaselineLabel.length > 0)
            {
                let phaseChangeBaselineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                //let BaselineState = this.state.BaselineLabel;  
                for (let k = 0; k < phaseChangeBaselineData.length; k++) {                         
                    if(phaseChangeBaselineData[k].dateMetBaseline != '1900-01-01T00:00:00' && k === 0)
                    {
                        var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                            if(data && data.key === 'Baseline')
                                return true;
                        });
                        if (indexValue !== -1) 
                            this.state.BaselineLabel.splice(indexValue, 1);
                    }
                }
                
                this.props.setBaselineState(false);            
                this.props.setGraphBaselineValue(this.state.BaselineLabel);         
                //this.setBaselineState(BaselineState);  
            }
    
            if(this.props.phaseChangeMasteredlineDataFlag && xAxisDate.length > 0 && this.props.displayphaseChangeLineWhenTheGoalWasMastered)
            {
                let phaseChangeMasteredlineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                let BaselineState = this.state.BaselineLabel;  
                for (let k = 0; k < phaseChangeMasteredlineData.length; k++) {                         
                    if(phaseChangeMasteredlineData[k].dateMastered != '1900-01-01T00:00:00' && k === 0)
                    {         
                        let lineIndex =xAxisDate.indexOf(moment(phaseChangeMasteredlineData[k].dateMastered).format('MM/DD/YYYY'));                    
                        var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                            if(data && data.key === 'Mastered')
                                return true;
                        });
                        // if (indexValue !== -1) 
                        //     this.state.BaselineLabel.splice(indexValue, 1);
                        if(indexValue === -1 && Number(lineIndex) >= 0)
                        {                        
                            let label = {
                                            id: 'plotLine_' + Math.random(),
                                            value: Number(lineIndex),
                                            color: '#000000',
                                            width: 2,
                                            key: "Mastered",
                                            dashStyle: phaseChangeMasteredlineData[k].masteredlineTypeName,                   
                                            label: {
                                                text: "Mastered"
                                            }
                                        };
                            
                            BaselineState.push(label);                                    
                        }
                    }
                }
                this.props.setMasteredlineState(false);
                this.setBaselineState(BaselineState && BaselineState[0] != undefined ? BaselineState : []);                  
            }
            else if(this.props.phaseChangeMasteredlineDataFlag && xAxisDate.length > 0 && !this.props.displayphaseChangeLineWhenTheGoalWasMastered && this.state.BaselineLabel && this.state.BaselineLabel.length > 0)
            {
                let phaseChangeMasteredlineData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
                //let BaselineState = this.state.BaselineLabel;  
                
                for (let k = 0; k < phaseChangeMasteredlineData.length; k++) {                         
                    if(phaseChangeMasteredlineData[k].dateMastered != '1900-01-01T00:00:00' && k === 0)
                    {                
                        var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                            if(data && data.key === 'Mastered')
                                return true;
                        });
                        if (indexValue !== -1) 
                            this.state.BaselineLabel.splice(indexValue, 1);                    
                    }
                }
                
                this.props.setMasteredlineState(false);            
                this.props.setGraphBaselineValue(this.state.BaselineLabel && this.state.BaselineLabel[0] != undefined ? this.state.BaselineLabel : []);         
               // this.setBaselineState(BaselineState);  
            }
    
        }

        if(xAxisDate.length && this.state.xAxisDateOption.length != xAxisDate.length)
            {
                let xAxisDate1 = [];
    
                xAxisDate1 = xAxisDate.map((d,i)=>{
                    return {
                        'id':i,
                        'value':d.toString()
                    }
                })
                
                this.setState({xAxisDateOption: xAxisDate1}
                    ,()=>{ this.setState({})}
                    );           
            }

        finalData.reverse();

        function formatSecondsToDate(seconds) {
            const date = new Date(new Date(seconds).toUTCString());
            let day = date.getUTCDate();
            let month = date.getUTCMonth() + 1;
            let year = date.getUTCFullYear();
      
            let formattedMonth = month < 10 ? `0${month}` : `${month}`;
            let formattedDay = day < 10 ? `0${day}` : `${day}`;
      
            let formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
            return formattedDate;
          }
      
        function modifyMulArrToSingleWithYAxis(arr,length,type){
          let updatedArr = [];
          if(type=="trendline" && arr.length){
            let emptyArry = new Array(length).fill(null);
            emptyArry[0] = parseFloat(arr[0][1].toFixed(2));
            emptyArry[length-1] = parseFloat(arr[1][1].toFixed(2));
            updatedArr = emptyArry;
          }else if(arr.length){
            for(let i=0;i<length;i++){
              if(arr[i] && arr[i][1] != null && arr[i][1] != undefined){
                updatedArr.push(parseFloat(arr[i][1].toFixed(2)))
              }else {
                updatedArr.push(null);
              }
            }
          }
          return updatedArr;
        }
        
        let chartData = [];
        let trendData = [];
        let averageLine = [];
        let trendLine = [];
        let lineChartTooltipName = (finalData.length && finalData.length < 2 && finalData[0] ) &&  finalData[0].name; 
        let isFinalChart = false;
        let isOtherLineChart = false;
        let sAvg;
        if(this.props.dataAnalytics.DCPatientSkillAcqGraphData !== null && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data != null && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs != null && this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.length > 0) {
            let graphHoursData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs;
            plotLines = []
            trendData = getTrendData(graphHoursData,"targetData","dos");
            averageLine = getAverageLine(trendData);
            trendLine = getTrendLine(trendData);
            sAvg = averageLine[0];
          }
      
    
    
    
        if(this.props.showTrendChart && !this.props.showDisplayAverage){
          isFinalChart = false;
          isOtherLineChart = true;
          chartData = [];
          chartData.push(
              {
                // type: 'scatter',
                type: 'line',
                name: lineChartTooltipName,
                data: modifyMulArrToSingleWithYAxis(trendData,trendData.length), 
                marker: {
                    radius: 4
                }
            },
            {
            
              type: 'line',
              name: 'Trend Line',
              data: modifyMulArrToSingleWithYAxis(trendLine,trendData.length,"trendline"),
              value: 454,
              width: 2,
              marker: {
                  enabled: false
              },
              dashStyle: 'longdash',
              color:"#000000"
            }
          );
          xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a)); 
        }
        else if(this.props.showDisplayAverage && !this.props.showTrendChart){
          isOtherLineChart = true;
          isFinalChart = false;
          chartData = [];
          plotLines.push({
            color:"#000000",
            width: 2,
            value: [sAvg],
            zIndex: 4,
            dashStyle: 'Dash',
            label: {
              text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
              align: 'right',
              x: 0,
              y: -10
          }
        });
          chartData.push(
              {
                // type: 'scatter',
                type: 'line',
                name: lineChartTooltipName,
                data: modifyMulArrToSingleWithYAxis(trendData,trendData.length),   
                marker: {
                    radius: 4
                }
            },
            {
              type: 'line',
              name: 'Average Line',
              data: modifyMulArrToSingleWithYAxis(averageLine,trendData.length,"trendline"),
              width: 2,
              marker: {
                enabled: false
              },
              color: 'transparent',
              dashStyle: 'shortdash',
            }
          );
          xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a));
        }else if(this.props.showTrendChart && this.props.showDisplayAverage){
          isOtherLineChart = true;
          isFinalChart = false;
          chartData = [];
          plotLines.push({
            color:"#000000",
            width: 2,
            value: [sAvg],
            zIndex: 4,
            dashStyle: 'Dash',
            label: {
              text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
              align: 'right',
              x: 0,
              y: -10
          }
        });
          chartData.push(
            {
              // type: 'scatter',
              type: 'line',
              name: lineChartTooltipName,
              data: modifyMulArrToSingleWithYAxis(trendData,trendData.length),   
              marker: {
                  radius: 4
              }
          },
          {
          
            type: 'line',
            name: 'Trend Line',
            data: modifyMulArrToSingleWithYAxis(trendLine,trendData.length,"trendline"),
            width: 2,
            marker: {
                enabled: false
            },
            dashStyle: 'longdash',
            color:"#000000"
          },{
            type: 'line',
            name: 'Average Line',
            data: modifyMulArrToSingleWithYAxis(averageLine,trendData.length),
            width: 2,
            marker: {
              enabled: false
            },
            color:"#000000",
            dashStyle: 'shortdash',
          }
        );
        xAxisDate = trendData.map(([a,b])=>formatSecondsToDate(a));
        }
        else{
          isOtherLineChart = false;
          isFinalChart = true;
          chartData = finalData;
        }

        if(displayAverage){
            let avgData = {}
            if (displayAverage && seriesCount > 0 && seriesCount > 0 ) {
                var seriesAvg = (seriesSum / seriesCount).toFixed(2);
                let avgD = {};

                let targetData = [];
                if(chartData[0] && chartData[0].data){
                    targetData = chartData[0].data;
                }
                let sAvg;
                if(targetData){    
                    let length = targetData.length;
                    let newArray = new Array(length);
                    sAvg = parseFloat(seriesAvg)
                    let filledArray = newArray.fill(null);
                    filledArray[0] = sAvg;
                    filledArray[newArray.length-1] = sAvg;
                    avgD = filledArray;
                }
                plotLines.push({
                    color:"#000000",
                    width: 2,
                    value: [sAvg],
                    zIndex: 4,
                    dashStyle: 'Dash',
                    label: {
                      text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
                      align: 'right',
                      x: 0,
                      y: -10
                  }
                });
                avgData = {
                        type: 'line',
                        name: 'Average Line',
                        data: avgD,
                        width: 2,
                        marker:{
                            enabled:false
                        },
                        color: 'transparent',
                        dashStyle: 'shortDash',
                    }
            }
            chartData.push(avgData)
        }


        Highcharts.setOptions({
            colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
        });
        
        //console.log('this.state.BaselineLabel............',this.state.BaselineLabel);
        
        let baselineLabel = [];
        if(this.state.BaselineLabel && this.state.BaselineLabel != undefined &&  this.state.BaselineLabel[0] &&  this.state.BaselineLabel[0] != undefined) {
            baselineLabel = this.state.BaselineLabel;
        }
        let SkillAcquisitionData = this.props.dataAnalytics.DCPatientSkillAcqGraphData.data.patientSkillsAcquisitionGraphs.map((obj) =>{
            return obj.targetData;
        })

        let maxValue = getMaxValue(SkillAcquisitionData);
        if(maxValue < 100){
            let plus20PercOnMaxValue = twentyPercentOf(maxValue);
            maxValue = maxValue + plus20PercOnMaxValue;
        }
        let maxYValue
        if (this.props.yAxisMaxValue) {
            maxYValue = this.state.sliderValue; 
        } else {
            maxYValue = (maxValue * this.state.sliderValue) / 100;
        }


        Highcharts.chart('analyticsDataDiv', {

            title: {
                text: selectedProgram
            },          
            annotations: this.state.AnnotationLabel,
            yAxis: {
                gridLineWidth: gridlinesWidth,
                minorGridLineWidth: gridlinesWidth,                
                title: {
                text: `<b>${xAxisLabel}</b>`
                },
                labels: {
                    enabled: disableYaxislabel
                },
                min: 0,
                max: maxYValue,
                plotLines: plotLines,
                maxPadding: 0.1,
                min: 0,
                max: maxYValue,
            },            
            legend: {
                align: 'left',
                verticalAlign: 'bottom',
                useHTML: true,
                enabled: disableLegend,
                reversed: false,                
                //itemWidth:260,
                itemStyle: {
                  'font-size': '14px',               
                  'letter-spacing': '0',
                  'line-height': '17px',
                  'text-align': 'center',
                        "textOverflow": "ellipsis"
                },            
            },            
            // legend: {
            //     layout: 'vertical',
            //     align: 'right',
            //     verticalAlign: 'middle',
            //     enabled: disableLegend,
            //     //itemWrap: false,  
            // },
            xAxis: {
                // type: isOtherLineChart && 'datetime',
                title: {
                    text: `<b>${yAxisLabel}</b>`,
                },
                tickLength: 0,
                categories: xAxisDate,
                labels: {
                    // rotation: isOtherLineChart && -45,
                    // formatter: isOtherLineChart && function() {
                    //   return Highcharts.dateFormat('%m/%d/%Y', this.value);
                    // },
                    enabled: disableXaxislabel
                },
                //plotLines: this.state.BaselineLabel && this.state.BaselineLabel != undefined &&  this.state.BaselineLabel[0] &&  this.state.BaselineLabel[0] != undefined ? this.state.BaselineLabel : [],
                plotLines: baselineLabel,
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                series: {
                    cursor: 'pointer',
                    connectNulls:true,
                    //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                    fillOpacity: 0.6,
                    label: {
                        connectorAllowed: false
                    },
                    dataLabels: {
                        enabled: false
                    },
                    events: {
                        legendItemClick: function () {
                            return false
                        }
                    },
                    marker: {
                        enabled: true        
                    }
                }
            },

            series: chartData,

            // series: [{
            //     name: 'Installation',
            //     data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
            // }, {
            //     name: 'Manufacturing',
            //     data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
            // }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom',
                            enabled: disableLegend
                        }
                    }
                }]
            },

            navigation: {
                buttonOptions: {
                    verticalAlign: 'top',
                    x: -100
                }
            },

            lang: {
                contextButtonTitle: 'Click to open'
            },

            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                }
            }
        });
    }

    onSliderChange = (value) => {     
        this.setState({
            sliderValue: value
        },()=> this.highchartsHandler());
    }

    render() {
        let { sliderValue } = this.state
        return (
            <div className='row'>
                <div className='col-sm-auto'>
                    <Slider 
                        min= {0}
                        max={this.state.sliderMaxValue}                           
                        value={sliderValue}
                        orientation="vertical"
                        onChange={(e)=>this.onSliderChange(e)}
                        tooltip={false}
                    />
                </div>
                <div className='col-sm-11'>
                    {this.state.xAxisDateOption.length > 0 ?   
                        <div className='row'>
                            <div className='col-sm-3'><GraphAnnotation setAnnotationState={this.setAnnotationState} xAxisDateOption={this.state.xAxisDateOption}/></div>
                            <div className='col-sm-3'><GraphPlotline setBaselineState={this.setBaselineState} xAxisDateOption={this.state.xAxisDateOption}/></div>
                            <div className='col-sm-6'></div>
                        </div>
                    : null}
                    <div id='analyticsDataDiv' style={{ height: '500px' }} />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {    
    return {
        dataAnalytics: state.dcSkillAcquisitionGraph,
        dataAnnotationLabel: state.dcSkillAcquisitionGraph.AnnotationLabel || [],
        dataBaselineLabel: state.dcSkillAcquisitionGraph.BaselineLabel || [],
    };
}

export default connect(mapStateToProps, {setGraphBaselineValue, setGraphAnnotationValue})(SkillAcquisitionGraph)



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionGraph/SkillAcuisitionGraph/SkillAcquisitionGraph.js